<mat-toolbar>
  <ng-content select="[left-side]"></ng-content>
  <ng-content select="[center]"></ng-content>
  <div>
    <app-menu-user [userName]="authenticatedUserService.displayName ?? ''">
      <ng-content select="[menu-user-items]" menu-user-items></ng-content>
    </app-menu-user>
  </div>
</mat-toolbar>
